export const themes = {
  lightTheme : {
    '--headerBackground' : '#efefef',
    '--bodyBackground' : '#fff',
    '--textColorPrimary': '#000',
    '--textColorSecondary': '#151515',
    '--textColorDark': '#4a4a4a',
    '--textHoverHighlight': '#848484',
    '--colorHighlight': '#772122',
  },
  darkTheme: {
    '--headerBackground' : '#000',
    '--bodyBackground' : '#151515',
    '--textColorPrimary': '#fff',
    '--textColorSecondary': '#fff',
    '--textColorDark': '#e0e0e0',
    '--textHoverHighlight': '#fff',
    '--colorHighlight': '#772122',
  }
};
